import React from 'react';
import { Button } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { getContentImageByMode } from '../../utils/imageUtils';
import { CountDown, formattedFlights, eventTypeValidate } from '../../utils/dateFnsUtils'
import { CONTENT_PROPS, IMAGE_CROP_MODES } from '../shared/constants';
import * as hooks from './hooks'

//#region ////// COMPONENTS //////flightsFormattedUntil
//#endregion

import './styles.scss';
import { EVENT_TYPES } from '../../constants/eventTypes';
import Imgcomponent, { LOADING_IMG } from '../../HOCs/ImageHocs';
import { IMAGE_MODE } from '../../constants/imageMode';
import FadeIn from 'react-fade-in/lib/FadeIn';
import ContentOverviewLiveSkeleton from './components/ContentOverviewLiveSkeleton';
import WithErrorBoundary from '../../HOCs/WithErrorBoundary';

function ContentOverviewLive({
  addButtonTitle,
  content,
  ctaButtonTitle,
  customAddButtonIcon = null,
  customCTAButtonIcon = null,
  hideButtons = false,
  hideButtonIcons = false,
  found_poster = false,
  found_thumb = false,
  thumb = '',
  onClickAddButtonHandler,
  onClickCTAButtonHandler,
  onClickPlayerButton,
  onClickMyListButton,
  onClickBackButton,
  translationTexts,
  networks,
  contentNoImageProps,
  isLoading = false,
  currentContentPosition,
  redirectContent = false,
  showPlayIcon = true
}) {
  const { 
    title, 
    flights, 
    contentType,
    sport, 
    live, 
    arrayFlightsStartEnd, 
    startFlight, 
    end, 
    eventType, 
    days, 
    hours, 
    minutes, 
    seconds 
  } = hooks.useContent(content);

  const { play_in, play_now, now_live, start_in, lang, continue_watching } = translationTexts ?? {};
  const network = !isLoading && Array.isArray(networks) && networks.find((element) => element?.network === content?.networks[0]?.network)
  const thumbBackground = !isLoading && getContentImageByMode(content?.images, "THUMB")?.url;
  const { currentContent, bookmark} = currentContentPosition ?? {};
  const { entitlementTypes } = currentContent  ?? {};

  const checkRedirect = (entitlementTypes) => {
    return entitlementTypes?.some((e) => (e === 'media'))
  }

  return (
    <React.Fragment>
      <div className="contentOverviewLiveContainer">
        <figure className="contentOverviewLiveBackground">
          {!isLoading && <Imgcomponent src={thumbBackground} crop={IMAGE_CROP_MODES.resizeScaleAndCrop} size={IMAGE_MODE.THUMB_OVERVIEW_LIVE} loading={LOADING_IMG.EAGER} />}
        </figure>
        <div className="contentOverviewLiveWrapper">
          <div className="contentOverviewLiveHedear">
            <FadeIn>
              <Button className="contentOverviewLiveExitButtom" onClick={() => onClickBackButton()}><i className="bi bi-arrow-left-short"></i></Button>
            </FadeIn>
          </div>
          <div className="contentOverviewLiveDetail">
            <div className="contentOverviewLiveInfo" >
            {isLoading ? <FadeIn><ContentOverviewLiveSkeleton backgroundColor={contentNoImageProps?.backgroundColorOne} foregroundColor={contentNoImageProps?.backgroundColorTwo} speed={2} /></FadeIn> :
            <FadeIn>
              {(eventType == EVENT_TYPES.IS_LIVE) &&
                <p className="contentOverviewLiveInfoBadge">
                  <span>{now_live}</span>
                </p>
              }
              <div className="contentOverviewLiveTitle">
                <h2>{title}</h2>
              </div>
              <div className="contentOverviewLiveData" >
                {!!network?.brandPresenceImage && <p className="contentOverviewLiveNetworkImgContent">
                  <img className="contentOverviewLiveNetworkImg" src={network.brandPresenceImage.url} />
                </p>}
                {sport && sport.league && <p className="contentOverviewLiveLeagueBadge">
                  <span>{sport.league}</span>
                </p>}
                {startFlight && (eventType == EVENT_TYPES.COMING_SOON) &&
                  <p className="contentOverviewLiveAvailableBadge">
                    <span>{`${formattedFlights(arrayFlightsStartEnd, 'start')}`}{lang == 'es' ? ' HS' : ''}</span>
                  </p>}
              </div>
              <div className="contentOverviewLiveActions">

              {(typeof onClickPlayerButton === 'function' && ((eventType == EVENT_TYPES.IS_LIVE) || (eventType == EVENT_TYPES.ON_DEMAND))) ?
                  <div>
                     { redirectContent  ?
                            <React.Fragment>
                               <span className="contentOverviewActionsPlayTitle">{`${play_in}: ${content.networks?.map((network) => network.name).join(', ')}`}</span>
                            </React.Fragment>
                            :
                            (!redirectContent && bookmark?.position > 0) ?
                              <React.Fragment>
                                { showPlayIcon && <i className="bi bi-play-fill"></i> }
                                <span className="contentOverviewActionsPlayTitle">{continue_watching}</span>
                              </React.Fragment>
                              :
                              <React.Fragment>
                                { showPlayIcon && <i className="bi bi-play-fill"></i> }
                                <span className="contentOverviewActionsPlayTitle">{play_now}</span>
                              </React.Fragment>
                          }
                  </div>
                  : (eventType === EVENT_TYPES.COMING_SOON) &&
                    <div>
                      <span className="contentOverviewLiveStartInLabel">{start_in}</span>
                      <p className="contentOverViewLiveCountdown">
                        <span>{`${days}d ${hours}h ${minutes}m ${seconds}s`}</span>
                      </p>
                    </div>
                }
              </div>
              </FadeIn>
            }
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

ContentOverviewLive.propTypes = {
  addButtonTitle: PropTypes.string,
  content: PropTypes.shape(CONTENT_PROPS).isRequired,
  ctaButtonTitle: PropTypes.string,
  customAddButtonIcon: PropTypes.func,
  customCTAButtonIcon: PropTypes.func,
  hideButtons: PropTypes.bool,
  hideButtonIcons: PropTypes.bool,
  onClickAddButtonHandler: PropTypes.func,
  onClickPlayerButton: PropTypes.func,
  onClickBackButton: PropTypes.func,
  networks: PropTypes.array,
  contentNoImageProps: PropTypes.object,
  isLoading: PropTypes.bool,
  currentContentPosition: PropTypes.object,
  redirectContent: PropTypes.bool,
  showPlayIcon: PropTypes.bool
};


export default WithErrorBoundary(React.memo(ContentOverviewLive));
